import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import SearchBarNE from '../../../../../shared/components/SearchBarNE/SearchBarNE';
import StyledButtonNE from '../../../../../shared/components/StyledButtonNE/StyledButtonNE';
import StyledMenu from '../../../../../shared/components/StyledMenu/StyledMenu';
import TabBarNE from '../../../../../shared/components/TabBarNE/TabBarNE';
import { FILTER_IMAGES } from '../../../../../shared/constants/images';
import { STORIES_OPTION_FILTER, STORIES_TYPE_MENU } from '../../../../../shared/constants/stories';
import { CLICK_ACTION, STORY_FILTER_DROPDOWN, STORY_SECTION } from '../../../../../shared/constants/tagManager';
import { IUserCompany } from '../../../../../shared/interfaces/businessData';
import { IStoriesFilter, IStoriesFilters } from '../../../../../shared/interfaces/stories';
import TagManagerService from '../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATION_STORIES_LIST } from '../../../../../shared/translations/stories';

import './StoriesTableFilter.scss';

interface StoriesTableFilterProps {
  company: IUserCompany;
  loading: boolean;
  storiesFilters: IStoriesFilters;
  changeStoriesFilters: (storiesFilters: IStoriesFilters) => void;
}

const StoriesTableFilter = ({ loading, company, storiesFilters, changeStoriesFilters }: StoriesTableFilterProps) => {
  const [currentTypeIndex, setCurrentTypeIndex] = useState<number>(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  const changeOption = (filterOption: IStoriesFilter) => {
    changeStoriesFilters({ ...storiesFilters, status: filterOption });
    handleClose();
    TagManagerService.pushEvent(CLICK_ACTION, STORY_FILTER_DROPDOWN, filterOption.gtmTag);
  };

  const handleButtonClick = async (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSearch = (search: string) => {
    changeStoriesFilters({ ...storiesFilters, searchValue: search });
  };

  const getLabelTexts = STORIES_TYPE_MENU.map((option) => t(option.label));

  const changeTab = (_event: React.ChangeEvent<unknown>, newValue: number) => {
    setCurrentTypeIndex(newValue);
    const option = STORIES_TYPE_MENU[newValue];
    TagManagerService.pushEvent(CLICK_ACTION, STORY_SECTION, option.gtmTag);
    changeStoriesFilters({ ...storiesFilters, type: option });
  };

  const tabBarParams = {
    items: getLabelTexts,
    action: changeTab,
    value: currentTypeIndex
  };

  const optionMenu = [
    { label: t(STORIES_OPTION_FILTER.allStories.filter), action: () => changeOption(STORIES_OPTION_FILTER.allStories) },
    {
      label: t(STORIES_OPTION_FILTER.visibleStories.filter),
      action: () => changeOption(STORIES_OPTION_FILTER.visibleStories)
    },
    {
      label: t(STORIES_OPTION_FILTER.hiddenStories.filter),
      action: () => changeOption(STORIES_OPTION_FILTER.hiddenStories)
    },
    {
      label: t(STORIES_OPTION_FILTER.scheduledStories.filter),
      action: () => changeOption(STORIES_OPTION_FILTER.scheduledStories)
    },
    {
      label: t(STORIES_OPTION_FILTER.permanentStories.filter),
      action: () => changeOption(STORIES_OPTION_FILTER.permanentStories)
    }
  ];

  useEffect(() => {
    setCurrentTypeIndex(0);
  }, [company]);

  return (
    <div className="stories-filter-container">
      <div className="stories-filter-tab">
        <TabBarNE tabItems={tabBarParams.items} action={tabBarParams.action} value={tabBarParams.value} />
      </div>

      <div className="filter-row column-mobile">
        <div className="filter-bar-container">
          <SearchBarNE
            placeholder={t(TRANSLATION_STORIES_LIST.search.detail)}
            onSearch={handleSearch}
            placeholderSmall={t(TRANSLATION_STORIES_LIST.search.mobile)}
            company={company}
            loading={loading}
          />
        </div>
        <div className="filter-button-container">
          <StyledButtonNE
            loading={loading}
            disabled={loading}
            buttonType="secondary"
            buttonSize="md"
            classes="filter-properties"
            action={handleButtonClick}
            image={FILTER_IMAGES}
          >
            {t(storiesFilters.status.filter)}
          </StyledButtonNE>
          <StyledMenu
            anchorEl={anchorEl}
            handleClose={handleClose}
            menuItems={optionMenu}
            anchorOrigin={undefined}
            transformOrigin={undefined}
          />
        </div>
      </div>
    </div>
  );
};

export default StoriesTableFilter;
